import React from "react";

const RoomEditor = ({
  name,
  setName,
  superficie,
  setSuperficie,
  handleSaveRoom,
  setIsEditing,
}) => {
  return (
    <div>
      <h2>Modifier la pièce</h2>

      <div className="mb-3">
        <label>Nom de la pièce</label>
        <input
          className="form-control"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label>Superficie (m²)</label>
        <input
          className="form-control"
          type="number"
          value={superficie}
          onChange={(e) => setSuperficie(e.target.value)}
        />
      </div>

      <div className="mt-4">
        <button
          className="btn btn-primary"
          style={{ backgroundColor: "var(--accent-orange)", border: "none" }}
          onClick={handleSaveRoom}
        >
          Sauvegarder
        </button>
        <button className="btn btn-secondary ms-2" onClick={() => setIsEditing(false)}>
          Annuler
        </button>
      </div>
    </div>
  );
};

export default RoomEditor;

